import { FC, useCallback, useMemo } from 'react'
import { Definition, DefinitionLabel, DefinitionValue, RackView } from '@cargomart/ui'
import { useNavigate } from '@tanstack/react-router'
import { formatMobilePhone, getFullNameFromFio } from 'helpers/string'
import { getDocumentLabel } from 'modules/profile/helpers'
import { profileInfoRoute } from 'modules/profile/routes'
import { UserDocumentTypeEnum } from 'modules/profile/types'
import { useTypedSelector } from 'src/hooks'
import { useUserInfoQuery } from 'src/modules/login/api'

const OrderYarcheCreateDeparturePartner: FC = () => {
  const { token } = useTypedSelector((state) => state.authReducer)
  const { data: user } = useUserInfoQuery(undefined, { refetchOnMountOrArgChange: true, skip: !token })
  const documents = useMemo(() => user?.document || [], [user?.document])

  const navigate = useNavigate()

  const handleNavigateProfile = useCallback(() => {
    navigate({ to: profileInfoRoute.to })
  }, [navigate])

  const documentView = useMemo(() => {
    const [document] = documents || []
    const { number, series, type } = document || {}

    if (!documents?.length) {
      return (
        <Definition>
          <DefinitionLabel>{getDocumentLabel()}</DefinitionLabel>
          <DefinitionValue>—</DefinitionValue>
        </Definition>
      )
    }

    const documentPassportRF = documents?.find((document) => document.type === String(UserDocumentTypeEnum.PassportRF))

    if (documentPassportRF) {
      return (
        <Definition>
          <DefinitionLabel>{getDocumentLabel(documentPassportRF.type)}</DefinitionLabel>
          <DefinitionValue>
            {documentPassportRF.series} {documentPassportRF.number}
          </DefinitionValue>
        </Definition>
      )
    }

    return (
      <Definition>
        <DefinitionLabel>{getDocumentLabel(type)}</DefinitionLabel>
        <DefinitionValue>
          {series} {number}
        </DefinitionValue>
      </Definition>
    )
  }, [documents])

  return (
    <>
      <div className="mb-2 text-body-md">
        В&nbsp;доставках посылок через магазины &laquo;Ярче&raquo; вы&nbsp;всегда выступаете в&nbsp;роли отправителя.
        Ваши данные можно изменить в&nbsp;
        <a className="link cursor-pointer" onClick={handleNavigateProfile}>
          настройках личного кабинета
        </a>
        .
      </div>

      <RackView className="mb-2 break-all" label={user?.firstname && user?.lastname ? getFullNameFromFio(user) : '—'}>
        <div className="grid grid-cols-1 px-3 py-1 md:grid-cols-2">
          <div>
            <Definition>
              <DefinitionLabel>Телефон</DefinitionLabel>
              <DefinitionValue>{formatMobilePhone(user?.phone)}</DefinitionValue>
            </Definition>
          </div>
          <div>{documentView}</div>
        </div>
      </RackView>
    </>
  )
}

export default OrderYarcheCreateDeparturePartner
